import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AdminWsProvider } from './context/AdminWsContext';
import { MainLayout } from './components/MainLayout';
import { Overview } from './views/Overview';
import { Devices } from './views/Devices';
import { Stats } from './views/Stats';
import { Settings } from './views/Settings';
import { Login } from './views/Login';
import { MapView } from './views/Map';

const DashboardContent = () => {
  const { isAuthenticated, authChecked, token, relayUrl } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  if (!authChecked) {
    return (
      <div className="spinner-wrap">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;

  return (
    <AdminWsProvider token={token} relayUrl={relayUrl}>
      <MainLayout activeTab={activeTab} setTab={setActiveTab}>
        {activeTab === 'overview'  && <Overview />}
        {activeTab === 'devices'   && <Devices />}
        {activeTab === 'stats'     && <Stats />}
        {activeTab === 'settings'  && <Settings />}
        {activeTab === 'map'       && <MapView />}
      </MainLayout>
    </AdminWsProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <DashboardContent />
    </AuthProvider>
  );
}

export default App;
